import { ADD_PAYMENT } from "@hopper-b2b/types";
import { trackBaseEvent } from "../utils";

export const trackNewPaymentMethod = async (context) =>
  trackBaseEvent(context, {
    eventName: ADD_PAYMENT,
    properties: {},
  });
